"use strict";

/* ============================================
   POSTERITY CLOTHING — THEME JS
   ============================================ */

document.addEventListener("DOMContentLoaded", function () {
  /* --- Scroll Reveal --- */
  const reveals = document.querySelectorAll(".reveal");
  const revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
        }
      });
    },
    { threshold: 0.12 },
  );
  reveals.forEach(function (el) {
    revealObserver.observe(el);
  });

  /* --- Header scroll behavior --- */
  const header = document.querySelector(".site-header");
  if (header) {
    window.addEventListener("scroll", function () {
      if (window.scrollY > 60) {
        header.classList.add("scrolled");
      } else {
        header.classList.remove("scrolled");
      }
    });
    if (window.scrollY > 60) header.classList.add("scrolled");
  }

  /* --- Mobile menu --- */
  const menuBtn = document.querySelector(".site-header__hamburger");
  const menu = document.querySelector(".mobile-menu");
  const menuClose = document.querySelector(".mobile-menu__close");

  if (menuBtn && menu) {
    menuBtn.addEventListener("click", function () {
      menu.classList.add("open");
      menuBtn.setAttribute("aria-expanded", "true");
    });
    if (menuClose) {
      menuClose.addEventListener("click", function () {
        menu.classList.remove("open");
        menuBtn.setAttribute("aria-expanded", "false");
      });
    }
    menu.querySelectorAll(".mobile-menu__link").forEach(function (link) {
      link.addEventListener("click", function () {
        menu.classList.remove("open");
        menuBtn.setAttribute("aria-expanded", "false");
      });
    });
  }

  /* --- Staggered reveal delays --- */
  document.querySelectorAll("[data-reveal-delay]").forEach(function (el) {
    el.style.transitionDelay = el.getAttribute("data-reveal-delay") + "s";
  });

  /* --- Hero video play button --- */
  const playBtn = document.querySelector(".hero__play-btn");
  const heroVideo = document.querySelector(".hero__video");
  if (playBtn && heroVideo) {
    playBtn.addEventListener("click", function (e) {
      e.preventDefault();
      if (heroVideo.paused) {
        heroVideo.play();
        heroVideo.classList.add("playing");
        playBtn.closest(".hero__play").style.opacity = "0";
      } else {
        heroVideo.pause();
        heroVideo.classList.remove("playing");
        playBtn.closest(".hero__play").style.opacity = "1";
      }
    });
  }

  /* --- Product image gallery --- */
  const thumbs = document.querySelectorAll("[data-product-thumb]");
  const mainImage = document.querySelector("[data-product-main-image]");
  if (thumbs.length && mainImage) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        const newSrc = this.getAttribute("data-product-thumb");
        mainImage.setAttribute("src", newSrc);
        mainImage.setAttribute(
          "srcset",
          newSrc.replace(/width=\d+/, "width=600") +
            " 600w, " +
            newSrc.replace(/width=\d+/, "width=900") +
            " 900w, " +
            newSrc.replace(/width=\d+/, "width=1200") +
            " 1200w",
        );
        thumbs.forEach(function (t) {
          t.closest(".product-detail__thumb").classList.remove("active");
        });
        this.closest(".product-detail__thumb").classList.add("active");
      });
    });
  }

  /* --- Collection Filtering --- */
  const filterBtns = document.querySelectorAll(".filter-btn[data-filter]");
  filterBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      const filter = this.getAttribute("data-filter");
      filterBtns.forEach(function (b) {
        b.classList.remove("active");
      });
      this.classList.add("active");
      document
        .querySelectorAll(".product-card[data-category]")
        .forEach(function (card) {
          if (
            filter === "all" ||
            card.getAttribute("data-category") === filter
          ) {
            card.style.opacity = "1";
            card.style.transform = "scale(1)";
            card.style.display = "";
          } else {
            card.style.opacity = "0";
            card.style.transform = "scale(0.98)";
            setTimeout(function () {
              card.style.display = "none";
            }, 400);
          }
        });
    });
  });

  /* --- Header always scrolled on non-home pages --- */
  if (!document.querySelector(".hero")) {
    const headerEl = document.querySelector(".site-header");
    if (headerEl) headerEl.classList.add("scrolled");
  }
});
let lastScroll = 0;
window.addEventListener('scroll', () => {
  const currentScroll = window.scrollY;
  const header = document.querySelector('header.site-header');
  if (!header) return;
  if (currentScroll > lastScroll && currentScroll > 80) {
    header.classList.add('header-hidden');
  } else {
    header.classList.remove('header-hidden');
  }
  lastScroll = currentScroll;
});

/* Hide floating header after hero scrolls out of view */
(function () {
  const header = document.querySelector('.site-header');
  const hero = document.querySelector('.hero, #shopify-section-hero');
  if (!header || !hero) return;

  const obs = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        header.classList.remove('is-hidden');
      } else {
        header.classList.add('is-hidden');
      }
    },
    { threshold: 0, rootMargin: '-80px 0px 0px 0px' }
  );

  obs.observe(hero);
})();

// PDP gallery
(function() {
  const gallery = document.getElementById('pdp-gallery');
  if (!gallery) return;
  const track = document.getElementById('pdp-track');
  const dots = gallery.querySelectorAll('.pdp__dot');
  const prev = gallery.querySelector('.pdp__arrow--prev');
  const next = gallery.querySelector('.pdp__arrow--next');
  const slides = track.querySelectorAll('.pdp__slide');

  function setActiveDot() {
    const idx = Math.round(track.scrollLeft / track.offsetWidth);
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === idx));
  }
  function scrollToSlide(idx) {
    track.scrollTo({ left: idx * track.offsetWidth, behavior: 'smooth' });
  }

  if (dots.length) dots[0].classList.add('is-active');
  track.addEventListener('scroll', setActiveDot);
  dots.forEach((dot, i) => dot.addEventListener('click', () => scrollToSlide(i)));
  if (prev) prev.addEventListener('click', () => {
    const idx = Math.round(track.scrollLeft / track.offsetWidth);
    scrollToSlide(Math.max(0, idx - 1));
  });
  if (next) next.addEventListener('click', () => {
    const idx = Math.round(track.scrollLeft / track.offsetWidth);
    scrollToSlide(Math.min(slides.length - 1, idx + 1));
  });
})();